import { axiosInstance } from '../common/api';

export const getEmployee = ({ start, pageSize, filters, globalFilter, sorting, status }) => {
  let url = `/user/?`;

  if (pageSize) url += `pageSize=${pageSize}&`;
  if (start) url += `start=${start}&`;
  if (filters) url += `filters=${filters}&`;
  if (globalFilter) url += `globalFilter=${globalFilter}&`;
  if (sorting) url += `sorting=${sorting}&`;
  if (status) url += `status=${status}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const getUserById = (id) => {
  const url = `/user/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const getUserTasksByUserIdAndProjectId = (userId, projectId) => {
  const url = `/user/tasks`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(url, { userId, projectId })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const createUser = (data) => {
  const url = `/user/add`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(url, data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
export const updateUser = (id, data) => {
  const url = `/user/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .put(url, data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const updateUserStatus = (id, action) => {
  const url = `/user/status/${id}/${action}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .put(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const updateUserMobileAccess = (id, action) => {
  const url = `/user/mobile-access/${id}/${action}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .put(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const updateUserAutoLeaveExclusion = (id, excludeFromAutoLeave) => {
  const url = `/user/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .put(url, { excludeFromAutoLeave })
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const deleteUser = (id) => {
  const url = `/user/${id}`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .delete(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const getUserRoles = () => {
  const url = `/user/roles`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const getusertimeline = ({ start, pageSize, globalFilter, sorting }) => {
  let url = `user/project-timeline?`;

  if (globalFilter) url += `globalFilter=${globalFilter}&`;
  if (sorting) url += `sorting=${sorting}&`;
  if (start) url += `start=${start}&`;
  if (pageSize) url += `pageSize=${pageSize}&`;

  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
